// This icon file is generated automatically.
var DrrpCheckSquareIconOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M953.6 32H70.4A38.35 38.35 0 0032 70.4v883.2A38.35 38.35 0 0070.4 992h883.2a38.35 38.35 0 0038.4-38.4V70.4A38.35 38.35 0 00953.6 32zM118.4 905.6V118.4h787.2v200.34c-48.77-1.57-175.11 2.46-181.32 2.46H668a38.2 38.2 0 00-31.08 15.96L448.4 598.76l-85.5-118.5a38.38 38.38 0 00-31.02-16.02H275.6a9.63 9.63 0 00-7.8 15.24l149.52 207.36a38.16 38.16 0 0062.04 0l217.74-301.9 208.5-1.77V905.6z" } }] }, "name": "drrp-check-square-icon", "theme": "outlined" };
export default DrrpCheckSquareIconOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/DrrpCheckSquareIconOutlined.js
// module id = 2494
// module chunks = 0